// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__IfrTO","box":"WorkspacesBox_box__HdeFB","node":"WorkspacesBox_node__1OZAH"};